import { render, staticRenderFns } from "./CRUDTableStaff.vue?vue&type=template&id=2e357980&scoped=true"
import script from "./CRUDTableStaff.vue?vue&type=script&lang=js"
export * from "./CRUDTableStaff.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableStaff.vue?vue&type=style&index=0&id=2e357980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e357980",
  null
  
)

export default component.exports